'use client'

import React, { FC } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import FooterItem, { Note } from './NotesFooterSection'

interface NotesFooterProps {
  notes: Note[]
  heading?: string
}

export const NotesFooter: FC<NotesFooterProps> = ({ notes, heading }) => {
  const { getTranslation } = useGetTranslations()

  const resolvedHeading = heading ?? getTranslation('notesFooterHeading')

  return (
    <section data-testid="notes-footer" className="bg-base-lightest w-full">
      <div className="mx-auto max-w-screen-xl px-6 py-10">
        <h2 className="text-primary-base mb-8 text-center text-2xl font-semibold">{resolvedHeading}</h2>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          {notes.map((note) => (
            <FooterItem key={note.id} {...note} />
          ))}
        </div>
      </div>
    </section>
  )
}
